import { render, staticRenderFns } from "./dependencies.vue?vue&type=template&id=0c666d5a&scoped=true&lang=pug"
import script from "./dependencies.vue?vue&type=script&lang=js"
export * from "./dependencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c666d5a",
  null
  
)

/* custom blocks */
import block0 from "./dependencies.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports